import React from 'react';
import { Grid, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { genderOptions } from './constant';
import FormLabelWithIcon from './FormLabelWithIcon';

export const GenderPicker = ({
  intl, options, onValueChange,
  field = 'gender',
  classes = {}, required = true,
  name = 'clients-gender',
  label = 'clients-gender'
}) => {
  return (
    <Grid className={classes?.sectionContainer || ''}>
      <FormLabelWithIcon
        iconName="User"
        labelText={intl.formatMessage({ id: label })}
        type="blue"
        required={required}
      />
      <FormControl>
        <RadioGroup
          row
          aria-label={label}
          name={name}
          value={options[field] || ''}
          onChange={event => onValueChange(field, event.target.value, options[field])}
        >
          {genderOptions.map(({ value, labelId }) => (
            <FormControlLabel
              key={value}
              value={value}
              control={<Radio color="primary" className={classes.radioOption} style={{ paddingTop: '2px', paddingBottom: '2px' }} />}
              label={intl.formatMessage({ id: labelId })}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};
